import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { HeaderCell, WidthCell } from './width-cells';

export const createWidthColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'width',
  Header: HeaderCell,
  Cell: WidthCell,
  width: 1,
  minWidth: 100,
});
